import { api } from "./apiClient";

export interface SimuladorRequest {
  tipoConvenio: string;
  buroCredito: string;
  seguro: string;
  frecuencia: string;
  antiguedad: number;
  ingresos: number;
  montoSolicitado: number;
  plazoMeses: number;
}

export interface AmortizacionRow {
  numero: number;
  desde: string;
  al: string;
  dias: number;
  pagoCapital: number;
  pagoIntereses: number;
  ivaIntereses: number;
  seguro: number;
  totalPeriodo: number;
  saldoCapital: number;
}

export interface SimuladorResponse {
  // Inputs procesados
  tipoConvenio: string;
  tipoClienteEfectivo: string;
  esDirectivo: boolean;
  buroCredito: string;
  seguro: string;
  frecuencia: string;
  antiguedad: number;
  ingresos: number;

  // Parámetros aplicados
  tasa: number;
  tasaAjustada?: number;
  comision: number;
  plazosDisponibles: number[];
  mesesSueldo: number;

  // Montos
  montoMaximo: number;
  montoSolicitado: number;
  montoCredito: number;
  capitalFinanciado?: number;
  plazoMeses: number;

  // Cálculos
  numPagos: number;
  interesTotal: number;
  totalAPagar: number;
  pagoParcialidad: number;
  costoSeguroParcialidad: number;
  pagoTotalParcialidad: number;

  // Comisión y seguro
  montoComision: number;
  ivaComision: number;
  seguroTotal: number;
  ivaSeguro: number;
  totalGeneral?: number;

  // Tabla de amortización
  tablaAmortizacion: AmortizacionRow[];

  // Error (si aplica)
  error?: string;
  antiguedadMinima?: number;
}

export interface ParametrosSimulador {
  costoSeguros: Record<string, number>;
  numPagosAnio: Record<string, number>;
  parametricosBuroBueno: Record<string, Record<string, any>>;
  parametricosBuroRegular: Record<string, Record<string, any>>;
  umbralDirectivo: number;
  antiguedadDirectivoInterno: number;
  antiguedadDirectivoExterno: number;
}

export const simuladorService = {
  /**
   * Ejecuta la simulación de crédito
   */
  simular: async (request: SimuladorRequest) => {
    return api.post<SimuladorResponse>("/simulador/", request);
  },

  /**
   * Obtiene los parámetros disponibles del simulador
   */
  obtenerParametros: async () => {
    return api.get<ParametrosSimulador>("/simulador/parametros");
  },
};
